import type IntegrationStore from '@src/service/integration-store'

import type { BaseIntegration } from './BaseIntegrationModel'
import { BaseIntegrationModel } from './BaseIntegrationModel'
import { createdByUserName } from './utils'

export interface RawGongIntegration extends BaseIntegration {
  readonly type: 'gong'
}

export class GongIntegrationModel extends BaseIntegrationModel<RawGongIntegration> {
  constructor(
    integrationStore: IntegrationStore,
    attrs: Partial<RawGongIntegration> = {},
  ) {
    const initialValues: RawGongIntegration = {
      id: '',
      type: 'gong',
      resourceIds: [],
      refreshToken: null,
      accessToken: null,
      logCalls: { enabled: false, activityType: null },
      logMessages: { enabled: false, activityType: null },
      accessTokenExpiresAt: null,
      contactProperties: [],
      callDepositions: [],
      contactImport: null,
      createdBy: null,
      userName: '',
    }

    super(integrationStore, initialValues, attrs)
  }

  get type(): 'gong' {
    return this.raw.type
  }

  override get userName(): string {
    return createdByUserName(this.raw.createdBy) ?? ''
  }
}

export const isGongIntegrationModel = (a: unknown): a is GongIntegrationModel => {
  return a instanceof GongIntegrationModel
}
